import { StyleSheet } from 'react-native';

export const createStyles = () =>
    StyleSheet.create({
        container: {
            flex: 1,
            backgroundColor: '#FFFFFF',
        },
        // 搜索栏区域
        searchBarContainer: {
            flexDirection: 'row',
            alignItems: 'center',
            paddingHorizontal: 12,
            paddingVertical: 8,
        },
        backButton: {
            paddingRight: 8,
            paddingVertical: 4,
        },
        searchBarWrapper: {
            flex: 1,
        },
        // 内容区域
        contentContainer: {
            flex: 1,
            paddingHorizontal: 16,
        },
        // Section 标题行
        sectionHeader: {
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginTop: 20,
            marginBottom: 12,
        },
        sectionTitle: {
            fontSize: 16,
            fontWeight: 'bold',
            color: '#333333',
        },
        sectionActions: {
            flexDirection: 'row',
            alignItems: 'center',
            gap: 12,
        },
        actionButton: {
            padding: 4,
        },
        clearText: {
            fontSize: 13,
            color: '#999999',
        },
        // 标签容器
        tagsContainer: {
            flexDirection: 'row',
            flexWrap: 'wrap',
            gap: 10,
        },
        // 标签
        tag: {
            paddingHorizontal: 14,
            paddingVertical: 8,
            backgroundColor: '#F5F5F5',
            borderRadius: 18,
        },
        tagText: {
            fontSize: 13,
            color: '#666666',
        },
        // 删除模式下的标签
        tagWithDelete: {
            flexDirection: 'row',
            alignItems: 'center',
            paddingHorizontal: 14,
            paddingVertical: 8,
            backgroundColor: '#F5F5F5',
            borderRadius: 18,
        },
        deleteIcon: {
            marginLeft: 6,
        },
    });
